var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { NewCascader } from '@feb-team/data-logic';
import { DivTag, UlTag, LiTag } from '../../Utils/AtomicTag';
import atomicsMapAddress from './AtomicMap';
import { LoadingOutlined, ClearOutlined, LocationOutlined } from '@feb-team/legao-icons-react';
import Input from '../Input';
var getFieldNames = function () {
    return {
        label: 'label',
        value: 'value',
        children: 'children',
    };
};
var getFilledFieldNames = function (props) {
    var fieldNames = getFieldNames() || {};
    var names = {
        children: fieldNames.children || 'children',
        label: fieldNames.label || 'label',
        value: fieldNames.value || 'value',
    };
    return names;
};
var Address = /** @class */ (function (_super) {
    __extends(Address, _super);
    function Address(props) {
        var _this = _super.call(this, props) || this;
        _this.container = React.createRef();
        _this.poper = React.createRef();
        _this.lastNode = null;
        _this.getShowData = function (activeValue) {
            var len = (activeValue === null || activeValue === void 0 ? void 0 : activeValue.length) || 0;
            if (activeValue && len > 0) {
                var lastNode = _this.entity.getNodes(activeValue[len - 1], _this.names.label)[0];
                _this.lastNode = lastNode;
                return _this.entity.getActive(lastNode).showNode;
            }
            return _this.entity.getLevelData(1);
        };
        _this.handleClickOutside = function (e) {
            var container = _this.container.current;
            var _a = _this.state, showClear = _a.showClear, showPopper = _a.showPopper;
            if (e.nativeEvent) {
                e.nativeEvent.stopImmediatePropagation();
            }
            if (container === null || container === void 0 ? void 0 : container.contains(e.target)) {
            }
            else {
                if (showPopper) {
                    _this.setState({
                        showPopper: false,
                    });
                }
                if (showClear) {
                    _this.setState({
                        showClear: false,
                    });
                }
            }
        };
        _this.handleInputClick = function (e) {
            e.nativeEvent.stopImmediatePropagation();
        };
        _this.handleChange = function (e, item) {
            e.nativeEvent.stopImmediatePropagation();
            _this.handleSelectOption(item);
        };
        _this.handleSelectOption = function (item) {
            if (item.Loading)
                return;
            var _a = _this.props, loadData = _a.loadData, onSelectEnd = _a.onSelectEnd;
            var currActives = _this.entity.getActive(item);
            var currNode = currActives.currNode;
            var activeLevel = (currNode[currNode.length - 1].tLevel
                ? currNode[currNode.length - 1].tLevel
                : 1);
            var activeData = currActives.showNode;
            var activeDeep = _this.entity.getOffspring(item.id).length;
            var activeValue = currNode.map(function (node) { return node[_this.names.label]; });
            var showPopper = !item.isRoot && item.isLeaf !== false ? false : _this.state.showPopper;
            _this.setState({
                activeData: activeData,
                activeValue: activeValue,
                activeDeep: activeDeep,
                showPopper: showPopper,
                showClear: !showPopper,
                activeLevel: activeDeep != 0 ? activeLevel + 1 : activeLevel,
            }, function () {
                _this.setValue(activeValue, currNode);
                if (item.isLeaf === false && !item[_this.names.children] && loadData) {
                    loadData(item);
                }
                if (!showPopper) {
                    onSelectEnd();
                }
            });
        };
        _this.setValue = function (value, selectedOptions) {
            var _a = _this.props, onChange = _a.onChange, onBeforeChange = _a.onBeforeChange;
            if (onBeforeChange(value, selectedOptions)) {
                onChange(value, selectedOptions);
            }
        };
        _this.handleTab = function (i) {
            _this.setState({
                activeLevel: i + 1,
            });
        };
        _this.handlePickerEvent = function () {
            var showPopper = _this.state.showPopper;
            if (!showPopper) {
                _this.setState({
                    showPopper: true,
                    showClear: false,
                });
            }
        };
        _this.handleInputFocus = function () {
            var showClear = _this.state.showClear;
            if (!showClear) {
                _this.setState({
                    showClear: true,
                });
            }
            _this.setState({
                isFocus: true,
            });
        };
        _this.handleInputBlur = function () {
            // const { showClear } = this.state
            // if (showClear) {
            //   this.setState({
            //     showClear: false,
            //   })
            // }
            _this.setState({
                isFocus: false,
            });
        };
        _this.handleClear = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.setState({
                activeValue: [],
                activeLevel: 1,
                showClear: false,
                showPopper: false,
            });
        };
        _this.handleInputEnter = function () {
            var _a = _this.state, showPopper = _a.showPopper, activeData = _a.activeData;
            if (showPopper || activeData.length == 0)
                return;
            _this.setState({
                showClear: true,
            });
        };
        _this.handleInputLeave = function () {
            _this.setState({
                showClear: false,
            });
        };
        _this.names = getFilledFieldNames(props);
        _this.entity = NewCascader(props.data, 'tree', { childrenKeyName: _this.names.children });
        var initValue = props.value || props.defaultValue || [];
        _this.state = {
            activeValue: initValue,
            activeDeep: _this.filterLevel(initValue),
            activeData: _this.filterActiveData(initValue),
            activeLevel: _this.lastNode ? _this.lastNode.tLevel : 1,
            showPopper: props.showPopper,
            inputFocused: false,
            showClear: false,
            isFocus: false,
        };
        return _this;
    }
    Address.prototype.componentWillReceiveProps = function (nextProps) {
        var _a;
        var _b = this.state, activeValue = _b.activeValue, showPopper = _b.showPopper, activeData = _b.activeData, activeDeep = _b.activeDeep, activeLevel = _b.activeLevel;
        var newState = {
            activeDeep: activeDeep,
        };
        if ('value' in nextProps) {
            newState.activeValue = nextProps.value;
        }
        if (nextProps.data && this.props.data !== nextProps.data) {
            this.entity = NewCascader(nextProps.data, 'tree', {
                childrenKeyName: this.names.children,
            });
            var initValue = nextProps.value || activeValue;
            newState.activeData = this.getShowData(initValue);
            newState.activeDeep = this.entity.getOffspring((_a = this.lastNode) === null || _a === void 0 ? void 0 : _a.id).length;
            //异步获取数据时新增数据自动移动tab
            if (activeValue.length === activeLevel && newState.activeDeep > activeValue.length) {
                this.setState({
                    activeLevel: newState.activeDeep,
                });
            }
        }
        if (newState.activeData || 'showPopper' in newState) {
            this.setState({
                activeData: newState.activeData ? newState.activeData : activeData,
                showPopper: newState.showPopper ? newState.showPopper : showPopper,
                activeValue: newState.activeValue ? newState.activeValue : activeValue,
                activeDeep: newState.activeDeep ? newState.activeDeep : activeDeep,
            });
        }
    };
    Address.prototype.componentDidMount = function () {
        document.addEventListener('click', this.handleClickOutside);
    };
    Address.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.handleClickOutside);
    };
    Object.defineProperty(Address.prototype, "fullTabTitle", {
        get: function () {
            var _a;
            var _b = this.state, activeValue = _b.activeValue, activeDeep = _b.activeDeep;
            var text = ['请选择'];
            if (activeDeep !== 0 && !((_a = this.lastNode) === null || _a === void 0 ? void 0 : _a.loading) && activeValue.length < 4) {
                //判断有默认值时 不添加请选择
                return activeValue.concat(text);
            }
            //清空按钮点击后
            if (activeValue.length == 0) {
                return activeValue.concat(text);
            }
            return activeValue;
        },
        enumerable: false,
        configurable: true
    });
    //异常默认地址处理
    Address.prototype.filterActiveData = function (initValue) {
        var len = initValue.length;
        if (len == 0)
            return this.getShowData(initValue);
        var tmp = initValue.slice();
        for (var i = 0; i < len; i++) {
            if (this.getShowData(tmp).length == 0) {
                tmp.splice(-1, 1);
            }
            else {
                return this.getShowData(tmp);
            }
        }
    };
    //异常默认地址处理
    Address.prototype.filterLevel = function (initValue) {
        var len = initValue.length;
        if (len == 0)
            return 1;
        var tmp = initValue.slice();
        for (var i = 0; i < len; i++) {
            if (this.getShowData(tmp).length == 0) {
                tmp.splice(-1, 1);
            }
            else {
                return tmp.length + 1;
            }
        }
    };
    Address.prototype.render = function () {
        var _this = this;
        var _a = this.props, placeholder = _a.placeholder, className = _a.className, onChange = _a.onChange, onBeforeChange = _a.onBeforeChange, loadData = _a.loadData, rightIcon = _a.rightIcon, rest = __rest(_a, ["placeholder", "className", "onChange", "onBeforeChange", "loadData", "rightIcon"]);
        var _b = this.state, activeData = _b.activeData, activeValue = _b.activeValue, activeLevel = _b.activeLevel, showPopper = _b.showPopper, showClear = _b.showClear, isFocus = _b.isFocus;
        var tab = this.fullTabTitle;
        var iptClass = ['cursor-pointer', 'truncate'];
        if (isFocus) {
            iptClass.push('shadow-input');
        }
        return (React.createElement(DivTag, __assign({ name: Address.NAME, atomics: atomicsMapAddress.Address, className: className, ref: this.container }, rest),
            React.createElement(DivTag, { atomics: ['relative', 'cursor-pointer'], onClick: this.handlePickerEvent, onMouseLeave: this.handleInputLeave, onMouseEnter: this.handleInputEnter },
                React.createElement(Input, { onFocus: this.handleInputFocus, onBlur: this.handleInputBlur, value: activeValue.join(''), placeholder: placeholder, clearable: false, readOnly: true, onClick: this.handleInputClick, className: iptClass.join(' ') }),
                React.createElement(DivTag, { atomics: [
                        'flex',
                        'absolute',
                        'h-full',
                        'right-0',
                        'top-0',
                        'w-px-32',
                        'items-center',
                        'justify-center',
                    ], style: { fontSize: '16px', pointerEvents: 'none' } }, showClear ? null : React.createElement(React.Fragment, null, rightIcon ? rightIcon : React.createElement(LocationOutlined, null))),
                showClear ? (React.createElement(DivTag, { atomics: [
                        'flex',
                        'absolute',
                        'h-full',
                        'right-0',
                        'top-0',
                        'w-px-32',
                        'items-center',
                        'justify-center',
                        'text-gray-400',
                    ], style: { fontSize: '16px' }, onClick: this.handleClear },
                    React.createElement(ClearOutlined, null))) : null),
            React.createElement(DivTag, { atomics: showPopper ? atomicsMapAddress.tab : atomicsMapAddress.tab.concat(['invisible']), ref: this.poper }, activeData ? (React.createElement(React.Fragment, null,
                React.createElement(DivTag, { atomics: atomicsMapAddress.tabControl }, tab.map(function (v, i) { return (React.createElement(DivTag, { onClick: _this.handleTab.bind(_this, i), atomics: i + 1 === activeLevel
                        ? atomicsMapAddress.tabBtn.concat(atomicsMapAddress.active)
                        : atomicsMapAddress.tabBtn, key: i }, v)); })),
                activeData &&
                    activeData.map(function (list, index) {
                        if (index + 1 === activeLevel) {
                            return (React.createElement(UlTag, { atomics: atomicsMapAddress.list, key: index }, list.map(function (item, i) { return (React.createElement(LiTag, { atomics: item.label && activeValue.indexOf(item[_this.names.label]) > -1
                                    ? atomicsMapAddress.item.concat(['text-brand-600'])
                                    : atomicsMapAddress.item, onClick: function (e) {
                                    _this.handleChange(e, item);
                                }, key: i },
                                item[_this.names.label],
                                item.loading ? React.createElement(LoadingOutlined, null) : null)); })));
                        }
                        else {
                            return null;
                        }
                    }))) : (React.createElement(DivTag, { atomics: ['flex', 'h-px-120', 'justify-center', 'items-center'] }, "\u6682\u65E0\u8BE5\u5730\u5740")))));
    };
    Address.defaultProps = defaultProps;
    Address.NAME = 'address';
    Address.displayName = 'Address';
    return Address;
}(PureComponent));
export { Address };
